import create from 'zustand';
import { MarketingQueryState } from './interfaces/CreateQueryState';
import { createCommonMarketingQuerySlice } from './slices/MarketingQuerySlices.ts/CommonMarketingQuerySlice';

export const useMarketingQueryStore = create<MarketingQueryState>((set) => ({
  ...createCommonMarketingQuerySlice(set)
}));
